
import AAF from '../../AAF/AAF';

import {
    LOGIN_NET,
    LOGIN_HDTV,
    STATUS_ACCOUNT_SUSPENDED,
} from '../../AAF/Auth/authConstants';

import Utils, {loginInterceptor, getSuspendedAccountLabels}  from '../../utils/Utils';
import { setMetricsEvent } from '../../actions/metrics';
import {
    MODAL_ACCEPT_TERM,
    AAF_MODAL_ERROR,
    AAF_MODAL_SUSPENDED_ACCOUNT,
    MODAL_TERM_AND_COND,
    MODAL_POLITICAS, MODAL_POLITICA_DE_PRIVACIDAD,MODAL_TERMINOS_Y_CONDICIONES,
} from '../../actions/modal';
import { setAacceptedTerms } from '../../reducers/user';
import {workflowstart, paywayConfirm, apaLegals, purchaseButtonInfo, getPurchaseNodeId} from '../../requests/loader';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import utilsIsSticky from '../../utils/user/IsSticky';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import { createAsyncEvent } from '../../utils/analytics';
import * as ipTelmexConstants from '../../containers/IPTelmex/constants';
import * as constants from '../../AAF/Auth/authConstants';
import BlockedChannels from '../../utils/BlockedChannels';
import UtilsProfile from '../../utils/Profile';
import channelBlockedUtil from '../../utils/ChannelBlockedUtil';
import LoadFav from '../../AAF/LoaderExp/LoadFav';
import {LABEL_INICIA_SESION, LABEL_IPTV_NEXT} from "../utils/constantsMetrics";
import Legals from '../../requests/apa/Legals';
import UtilsIsLoggedIn from '../../utils/user/isLoggedIn';
import {checkAccountStatus} from 'src/AAF/Auth/login';
import { LOGIN_RESPONSE_TYPE } from 'src/AAF/Auth/authConstants';
import { getUrlRedirectBack } from 'src/components/Modal/functions/ModalKeepWatching/functions';
import store from './../../store';
import NewRelic from 'src/utils/trackers/NewRelic';

class LoginLogicOTP {
    constructor(props) {
        this.props = props;
        const isIpTelmex =
            this.props.history.location.state && props.history.location.state.ipTelmex;
        this.stickySuccess = this.stickySuccess.bind(this);
        this.showSuspendedAccountModal = this.showSuspendedAccountModal.bind(this);

        this.analyticsEvent = createAsyncEvent({
          send: (event) => {
              setMetricsEvent(event);
              setMetricsEvent({ type: 'executor' });
          },
          label: isIpTelmex ? ipTelmexConstants.IPTELMEX_LOGIN_EVENT_LABEL : constants.LOGIN_EVENT_LABEL,
          action: isIpTelmex ? ipTelmexConstants.IPTELMEX_LOGIN_EVENT_ACTION : constants.LOGIN_EVENT_ACTION,
          category: isIpTelmex
              ? ipTelmexConstants.IPTELMEX_LOGIN_EVENT_CATEGORY
              : constants.LOGIN_EVENT_CATEGORY,
          successLabel: isIpTelmex
              ? ipTelmexConstants.IPTELMEX_LOGIN_EVENT_SUCCESS_LABEL
              : constants.LOGIN_EVENT_SUCCESS_LABEL,
          errorLabelPrefix: isIpTelmex
              ? ipTelmexConstants.IPTELMEX_LOGIN_EVENT_ERROR_LABEL_PREFIX
              : constants.LOGIN_EVENT_ERROR_LABEL_PREFIX,
      });
    }

    isNetVendor() {
        const netProviders = [LOGIN_NET, LOGIN_HDTV];
        return netProviders.includes(this.props.location.typeRegisterNet);
    }

    showPrivacyPolicyModal(cb){

        UtilsIsLoggedIn.showPrivacyPolicyModal((accepted) => {
          if (accepted) {
            //Actualizar el estado
            store.dispatch(setAacceptedTerms(1));
            this.setState({
              isFetching: false,
              focusReady: true
            });
          }

          if ('function' === typeof cb) cb();

        })
      }

      showSuspendedAccountModal(){
        this.props.history.push('/suspended-account');
        UtilsIsLoggedIn.setIntervalSuspendedAccount();
        const modal = {
          modalType: AAF_MODAL_SUSPENDED_ACCOUNT,
          modalProps: { buttonsAlign: 'vertical' , ...getSuspendedAccountLabels()}
        };
        this.props.showModal(modal);
      }

    async loginFLow(dataLogin, loginOTPFunction) {
        const response = await this.performLogin(dataLogin, loginOTPFunction);
        if (!response) {
            result = response;
        }
        if (response && response.success) {
            loginInterceptor(response.data);

            await this.successLogin(response.data);
        } else {
            switch (response.error.code) {
                case LOGIN_RESPONSE_TYPE.ACCEPT_TERMS:
                    await this.continueAcceptTermFlow(response)
                    break;
                case 'user_login_captcha_required':
                  LoginLogicOTP.setCaptcha();
                  break;
                case 'user_login_invalido':
                  return response.error;
                  default:
                    this.analyticsEvent.error(response.error);
                    return response.error;
            }
            Utils.behaviorOfError(response.error, this.props.handleErrors, this.showModal);
        }
        Utils.setCustomAttribute();

        const { user } = store.getState();

        if (user.isSuspendedAccount) {
            //Verifica que la modal que se este mostrando es la de politicas
            const modals = [MODAL_POLITICAS, MODAL_POLITICA_DE_PRIVACIDAD,MODAL_TERMINOS_Y_CONDICIONES]
            if (modals.includes(Utils.modalType())){
                //Encola la modal de suspension y vuelve a mostrar politicas de privacidad

                this.showPrivacyPolicyModal(this.showSuspendedAccountModal);
            } else {
                this.showSuspendedAccountModal();
            }
        }
    }

    static setCaptcha() {
        // TODO ¿Hay captcha?, no hay bocetos de  cómo mostrar captcha, se sigue usando?
        const captchaUrl = AAF.Auth.login.getCaptcha();
        console.log('Captcha URL: ' + captchaUrl);
    }

    showAcceptTerm(entryParams = {}) {
        this.setDataLegal();
        LoginLogicOTP.getConfigRemoteControl();
        const modal = {
            modalType: MODAL_ACCEPT_TERM,
            modalProps: {
                onAccept: () => this.acceptTermAndCond(entryParams),
                onShowTermAndCond: () => this.onShowTermAndCond(),
            },
        };
        this.props.showModal(modal);
    }

    async acceptTermAndCond(entryParams = {}) {
        try {
            const { email, password } = entryParams;
            const params = { ...{ terminos: 1 }, ...{ email, password, username: '' } };
            if (params.email) {
                params.username = params.email;
            }

            AAF.Auth.login
                .acceptTermAndCond(params)
                .then((response) => {
                    if (response.success) {
                        this.handleSubmit();
                    } else {
                        const modal = {
                            modalType: AAF_MODAL_ERROR,
                            modalProps: {
                                callback: () => {},
                                content: response.error,
                            },
                        };
                        this.props.showModal(modal);
                    }
                })
                .catch((err) => {
                    console.log('Error accept terms');
                });
        } catch (error) {
            console.error(error);
        }
    }

    async onShowTermAndCond() {
        const modal = {
            modalType: MODAL_TERM_AND_COND,
            modalProps: {
                onShowAcceptTerm: () => this.showAcceptTerm(),
            },
        };
        this.props.showModal(modal);
    }

    setDataLegal() {
        Legals.setData(apaLegals());
    }

    checkPrivacyPolicy(response, isIPTV){

        const { accepted_terms = 1 , isSuspendedAccount =false} = response || {};
        const code = response && response.errors && response.errors.code ? response.errors.code : '';
        const codeAdvertising = response && response.errors  && response.errors[0] ? response.errors[0].code : '';
        const validateCode = (code === LOGIN_RESPONSE_TYPE.ACCEPT_TERMS || codeAdvertising === LOGIN_RESPONSE_TYPE.ACCEPT_TERMS_ADVERTISING);

        if (!isIPTV && accepted_terms === 0 && validateCode) {
            this.showSuspendedAccountOrPrivacyPolicyModal(isSuspendedAccount);
        }
    }


    async successLogin(response) {

        const isIPTV = Utils.isPTV(response);
        this.checkPrivacyPolicy(response, isIPTV)

        if (isIPTV) {
            Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, LABEL_IPTV_NEXT, LABEL_INICIA_SESION);
            DeviceStorage.unsetItem('_epgDBStartTime_');
            DeviceStorage.unsetItem('_epgDBEndTime_');
        }

        if (window.youboraTrackingPlugin) {
            if (window.youboraTrackingPlugin.storage) {
                if (
                    window.youboraTrackingPlugin.storage.removeLocal &&
                    typeof window.youboraTrackingPlugin.storage.removeLocal === 'function'
                ) {
                    window.youboraTrackingPlugin.storage.removeLocal('data');
                }
                if (
                    window.youboraTrackingPlugin.storage.removeSession &&
                    typeof window.youboraTrackingPlugin.storage.removeSession === 'function'
                ) {
                    window.youboraTrackingPlugin.storage.removeSession('data');
                }
            }
            if (
                window.youboraTrackingPlugin.restartViewTransform &&
                typeof window.youboraTrackingPlugin.restartViewTransform === 'function'
            ) {
                window.youboraTrackingPlugin.restartViewTransform();
            }
        }

        if (window.youboraAnalyticsPlugin) {
            if (window.youboraAnalyticsPlugin.infinity) {
                if (
                    window.youboraAnalyticsPlugin.infinity.fireSessionStop &&
                    typeof window.youboraAnalyticsPlugin.infinity.fireSessionStop === 'function'
                ) {
                    window.youboraAnalyticsPlugin.infinity.fireSessionStop();
                }
                if (
                    window.youboraAnalyticsPlugin.infinity.fireSessionStart &&
                    typeof window.youboraAnalyticsPlugin.infinity.fireSessionStart === 'function'
                ) {
                    window.youboraAnalyticsPlugin.infinity.fireSessionStart();
                }
            }
        }

        const pushSession = Utils.getApaMetadataKey(
            'sticky_session',
            '{"push_session":false,"user_id":false}',
            'push_session'
        );
        console.log('[JONY]-pushSession', pushSession);
        if (pushSession) {
            await utilsIsSticky
                .getPushSessionRegister(response)
                .then(() => {
                    this.stickySuccess(response);
                    Utils.setCustomAttribute();
                })
                .catch((err) => {
                    const { showModal } = this.props;
                    showModal({
                        modalType: AAF_MODAL_ERROR,
                        modalProps: {
                            content: err.response,
                        },
                    });
                });
        } else {
            this.stickySuccess(response);
        }
        LoadFav.start();
    }

    /**
     *
     * @param {*} response en este caso, es la respuesta de successLogin
     */
    stickySuccess(response) {
        new AnalyticsDimensionSingleton().setUser(this.props.user);
        this.analyticsEvent.success();

        this.props.fetchLinealChannels(response.user_id);

        const region = DeviceStorage.getItem('region');
        DeviceStorage.setItem('user_hash', response.session_userhash);
        if (response.user_id) {
            DeviceStorage.setItem('user_id', response.user_id);
            NewRelic.setUserId(response.user_id);
        }
        this.updateBlockedChannels();
        if (region !== response.region) {
            DeviceStorage.setItem('region', response.region);
            window.location.href = `/${UtilsProfile.isProfileEnable(this.props.user) ? 'profile' : ''}`;
        } else {
            if (UtilsProfile.isProfileEnable(this.props.user)) {
                this.props.receiveIsLoggedIn(response);
                const urlRedirect = getUrlRedirectBack('/profile');
                this.props.history.replace(urlRedirect);
            } else {
                this.props.receiveIsLoggedIn(response);
                const urlRedirect = getUrlRedirectBack('/node/homeuser');
                this.props.history.push(urlRedirect);
            }
        }
        LoginLogicOTP.getConfigRemoteControl();
    }

    updateBlockedChannels() {
        const blockedChannelsList = new BlockedChannels();
        blockedChannelsList.checkBlockedChannels().then((response) => {
            channelBlockedUtil.set('blockedChannels', response);
        });
    }

    static getConfigRemoteControl() {
        let rcConfigControl = DeviceStorage.getItem('config_remote_control');
        if (!rcConfigControl) {
            rcConfigControl = Utils.getRegionaliazedMetadata(
                'rc_default_config',
                '{"default":{"enable":false,"config":"full"}}'
            ).config;
            if (!rcConfigControl) rcConfigControl = 'full';
        }
        DeviceStorage.setItem('config_remote_control', rcConfigControl);
    }

    async performLogin(dataLogin, loginFunction) {
        const response = { success: false };
        let suspendedAccountStatus = 'undefined';
        try {
            const result = await loginFunction(dataLogin);
            console.log(result);
            if ((result && result.status === '0') || result.response.user_token) {
                response.success = true;
                response.data = result.response;
                if (result.response.user_token) {
                    DeviceStorage.setItem('user_token', result.response.user_token);
                    AAF.Database.setUserToken(result.response.user_token);
                }
                if (this.isNetVendor()) {
                    if (result && result.response) {
                        Utils.setHKS(result);
                    }
                    if (
                        response.data.hasUserSusc === 0 &&
                        response.data.purchase &&
                        response.data.purchase.url
                    ) {
                        const requets = Utils.getRequest(response.data.purchase.url);
                        const params = {};
                        params.linkworkflowstartParams = requets.params;
                        const netSubscriptionSuccess = await workflowstart(params).then(
                            this.workflowstartSuccess,
                            this.workflowstartFail
                        );

                        if (!netSubscriptionSuccess) {
                            return;
                        }

                        response.data.hasSavedPayway = 1;
                        response.data.hasUserSusc = 1;
                        response.data.subscriptions = {
                            AMCO: true,
                        };
                    }
                }
                suspendedAccountStatus = await checkAccountStatus(result);
            }
        } catch (error) {
            const {code} = error || {};
            if(code === LOGIN_RESPONSE_TYPE.ACCEPT_TERMS) {
                return await this.acceptTermFlow(error);
            }
            response.error = error;
        }

        return {...response,
            data: {
             ...response.data,
            isSuspendedAccount:suspendedAccountStatus === STATUS_ACCOUNT_SUSPENDED
        }};
    }

    async continueAcceptTermFlow(response){
        AAF.Resilence.filterIsloggedin(response)
        const {error : {completeError : { response: errorResponse = {} } = {} }= {}} = response || {};
        const data = {...response.data,...errorResponse}
        loginInterceptor(data);
        await this.successLogin(data);
    }

    async acceptTermFlow(error){

        const response = { success: false };
        const {code, completeError : {response : responseData} = {}} = error || {};
        let suspendedAccountStatus = 'undefined';
        try {
            if (code === LOGIN_RESPONSE_TYPE.ACCEPT_TERMS) {
                response.success = true;
                response.data = {
                    ...responseData,
                    errors: { code }
                };
                if (this.isNetVendor()) {
                        Utils.setHKS(response.data);
                    if (
                        response.data.hasUserSusc === 0 &&
                        response.data.purchase &&
                        response.data.purchase.url
                    ) {
                        const requets = Utils.getRequest(response.data.purchase.url);
                        const params = {};
                        params.linkworkflowstartParams = requets.params;
                        const netSubscriptionSuccess = await workflowstart(params).then(
                            this.workflowstartSuccess,
                            this.workflowstartFail
                        );

                        if (!netSubscriptionSuccess) {
                            return;
                        }

                        response.data.hasSavedPayway = 1;
                        response.data.hasUserSusc = 1;
                        response.data.subscriptions = {
                            AMCO: true,
                        };
                    }
                }
                suspendedAccountStatus = await checkAccountStatus(response.data);
                return {...response,
                    data: {
                     ...response.data,
                    isSuspendedAccount:suspendedAccountStatus === STATUS_ACCOUNT_SUSPENDED
                }};
            }
        } catch (error) {
            console.error('acceptTermFlow error', error)
            return {};
        }
    }

    showSuspendedAccountOrPrivacyPolicyModal(isSuspendedAccount){
        if (isSuspendedAccount) {
            this.showPrivacyPolicyModal(this.showSuspendedAccountModal);
        }else {
            this.showPrivacyPolicyModal();
        }
    }

    async workflowstartFail(error) {
        const modal = {
            modalType: AAF_MODAL_ERROR,
            modalProps: {
                callback: () => this.props.handleFocus(),
                content: error,
            },
        };
        this.props.showModal(modal);
        return false;
    }

    async workflowstartSuccess(resp) {
        if (resp && resp.status === '0') {
            resp = resp.response;
            const methods = resp.list;

            for (let i = 0; i < methods.length; i++) {
                const method = methods[i];
                if (method.gateway === 'netgate' && method.buyLink) {
                    const requets = Utils.getRequest(method.buyLink);
                    return await paywayConfirm(requets.uri, requets.params).then(
                        LoginLogicOTP.paywayConfirmSuccess,
                        this.paywayConfirmFail
                    );
                }
            }
        }
        return false;
    }

    static async paywayConfirmSuccess(resp) {
        return !!(resp &&
          resp.status === '0' &&
          resp.response &&
          resp.response.success &&
          resp.response.success === 1);
    }

    async paywayConfirmFail(error) {
        const modal = {
            modalType: AAF_MODAL_ERROR,
            modalProps: {
                callback: () => this.props.handleFocus(),
                content: error,
            },
        };
        this.props.showModal(modal);
        return false;
    }
}

export default LoginLogicOTP;



// WEBPACK FOOTER //
// ./src/authentication/Login/LoginLogicOTP.js